import {
  Directive,
  inject,
  Input,
  TemplateRef,
  ViewContainerRef,
} from '@angular/core';
import { Rule } from '@api';
import { UserStore } from '@app/store/user.store';
import { ConstStore } from '@store/const.store';

@Directive({
  selector: '[appRight]',
  standalone: true,
})
export class RightDirective {
  private _right!: Rule.TypeEnum[];
  private _rules?: Rule[];
  private hasView = false;
  userStore = inject(UserStore);

  constructor(
    private templateRef: TemplateRef<any>,
    private viewContainer: ViewContainerRef
  ) {}

  @Input() set appRight(context: { right?: Rule.TypeEnum[]; rules?: Rule[] }) {
    this._right = context.right || [];
    this._rules = context.rules;

    const hasRight =
      this.userStore.user().admin ||
      this._rules?.some(
        (rule) =>
          this._right?.includes(rule.type) &&
          rule.profileId === this.userStore.user()?.profileId &&
          (rule.agencies.includes(this.userStore.contract().agencyId || -1) ||
            rule.activities.includes(
              this.userStore.contract().activityId || -1
            ) ||
            rule.contracts.includes(this.userStore.contract() || -1) ||
            rule.all)
      );

    if (hasRight) {
      if (!this.hasView) {
        this.viewContainer.createEmbeddedView(this.templateRef);
        this.hasView = true;
      }
    } else {
      if (this.hasView) {
        this.viewContainer.clear();
        this.hasView = false;
      }
    }
  }
}
